import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import DialogTitle from '../DialogTitle';
import DialogTransition from '../DialogTransition';

/**
 * プロパティ
 */
export type Props<T> = {
  /** comp */
  comp: React.FC<{
    /** データ */
    data: T,
  }>,
  /** データ */
  data: T | undefined,
  /** 削除 */
  onDelete: (input: T | undefined) => void,
  /** タイトル */
  title: string,
  /** コンテンツ */
  content: string,
}

/**
 * 削除
 * @param props プロパティ
 * @returns コンポーネント
 */
// eslint-disable-next-line comma-spacing
const Delete = <T,>(props: React.PropsWithChildren<Props<T>>) => {
  const {
    comp,
    data,
    onDelete,
    title,
    content,
  } = props;
  return (
    <Dialog
      open={data !== undefined}
      onClose={() => onDelete(undefined)}
      fullScreen
      TransitionComponent={DialogTransition}
    >
      <DialogTitle title={title} />
      <DialogContent>
        <p>{content}</p>
        {data && comp({ data })}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => onDelete(data)} color="primary">
          削除する
        </Button>
        <Button variant="contained" onClick={() => onDelete(undefined)} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Delete;
